import { createCustomAction } from 'typesafe-actions';

import { standardEmptyACC, standardFailedACC } from '../../utils/sagas';

const REQUESTED = '$FETCH_PAY_LATER_RULES/REQUESTED';
const BLOCKED = '$FETCH_PAY_LATER_RULES/BLOCKED';
const APPROVED = '$FETCH_PAY_LATER_RULES/APPROVED';
const SUCCEEDED = '$FETCH_PAY_LATER_RULES/SUCCEEDED';
const FAILED = '$FETCH_PAY_LATER_RULES/FAILED';

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, standardEmptyACC),
  approved: createCustomAction(APPROVED, standardEmptyACC),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
